import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, ArrowRight } from "lucide-react";
import { VeraAvatar } from "@/components/tour/VeraAvatar";
import { api } from "@/lib/api";

export function OnboardingChecklist({ lang = "en", dark = false, hideWhenDone = false }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/tour-checklist", { params: { lang } }).then((r) => setD(r.data)).catch(() => {}); }, [lang]);
  if (!d || (hideWhenDone && d.done === d.total)) return null;
  const es = lang === "es";
  const pct = Math.round((d.done / d.total) * 100);
  return (
    <div className={dark ? "mt-4 bg-white/5 border border-white/10 rounded-xl p-4" : "bg-white border border-slate-200 border-l-4 border-l-emerald-500 rounded-lg p-5 flex gap-4 items-start"} data-testid="onboarding-checklist">
      {!dark && <VeraAvatar size={52} />}
      <div className="flex-1">
        <div className="flex items-center justify-between gap-3">
          <div className={`text-sm font-semibold ${dark ? "text-white" : "text-slate-900"}`}>{es ? "Tus primeros pasos con Vera" : "Your first steps with Vera"}</div>
          <span className={`text-xs ${dark ? "text-emerald-300" : "text-emerald-700"} font-semibold`} data-testid="onboarding-progress">{d.done}/{d.total}</span>
        </div>
        <div className={`h-1.5 rounded-full mt-2 ${dark ? "bg-white/10" : "bg-slate-100"}`}><div className="h-1.5 rounded-full bg-emerald-500 transition-all duration-500" style={{ width: `${pct}%` }} /></div>
        <ul className="mt-3 space-y-2">
          {d.items.map((i) => (
            <li key={i.key} data-testid={`onboarding-item-${i.key}`}>
              <Link to={i.to} className={`flex items-center gap-2 text-sm group ${dark ? "text-slate-200" : "text-slate-700"}`}>
                {i.done ? <CheckCircle2 className="h-4 w-4 text-emerald-500 shrink-0" data-testid={`onboarding-done-${i.key}`} /> : <Circle className={`h-4 w-4 shrink-0 ${dark ? "text-slate-500" : "text-slate-300"}`} />}
                <span className={`flex-1 ${i.done ? "line-through opacity-60" : ""}`}>{i.label}</span>
                <span className={`text-xs ${dark ? "text-slate-400" : "text-slate-500"}`}>{i.detail}</span>
                {!i.done && <ArrowRight className="h-3.5 w-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />}
              </Link>
            </li>
          ))}
        </ul>
        {d.done === d.total && <p className={`text-xs mt-2 ${dark ? "text-emerald-300" : "text-emerald-700"}`}>{es ? "¡Todo listo! Buen trabajo." : "All done! Nice work."}</p>}
      </div>
    </div>
  );
}
